import React, { JSX, useCallback, useState } from "react";
import { useTranslation } from "react-i18next";

import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import TextField from "@mui/material/TextField";

import { ReportInfo } from "trajectory/TrajectoryService";
import { asTitle } from "utils/Utils";
import { format } from "date-fns/format";
import { parseISO } from "date-fns/parseISO";

export type SplitScreenProps = {
	reports: ReportInfo[];

	onSelect: (id: number) => Promise<void>;
	onClose: () => void;
};

export default function SplitscreenDialog(
	props: Readonly<SplitScreenProps>
): JSX.Element {
	const { t } = useTranslation();
	const [filter, setFilter] = useState("");

	const handleFilterUpdate = useCallback(
		(event: React.ChangeEvent<HTMLInputElement>) => {
			setFilter(event.target.value);
		},
		[]
	);

	function getReportName(report: ReportInfo): string {
		return `${format(parseISO(report.created), "dd/MM/yyyy HH:mm:ss")} (${
			report.name
		})`;
	}

	return (
		<Dialog onClose={props.onClose} open={true}>
			<DialogTitle>
				{asTitle(t("selectDocument", { document: t("report") }))}
			</DialogTitle>
			<List>
				<ListItem>
					<TextField
						variant="standard"
						size="small"
						fullWidth
						label={asTitle(t("filter"))}
						value={filter}
						onChange={handleFilterUpdate}
					/>
				</ListItem>
				{props.reports
					.filter(report =>
						getReportName(report)
							.toLowerCase()
							.includes(filter.toLowerCase())
					)
					.map(report => (
						<ListItemButton
							key={report.id}
							onClick={() => props.onSelect(report.id)}>
							<ListItemText>
								{`${asTitle(t("report"))} ${getReportName(
									report
								)}`}
							</ListItemText>
						</ListItemButton>
					))}
			</List>
		</Dialog>
	);
}
